import React from "react";
import { NavLink } from "react-router-dom";
import { Button, Card } from "semantic-ui-react";

import "../../../static/priestProfile.css";

interface IFileCardProps {
    editMode: boolean;
    index: number;
    file: string;
    fileName: string;
    handleDeleteFile(index: number, file: string): void;
}

const FileCard: React.FC<IFileCardProps> = (props: IFileCardProps) => {
    const { editMode, index, file, fileName, handleDeleteFile } = props;

    const handleDeleteFilePressed = () => {
        handleDeleteFile(index, file);
    };

    return (
        <Card>
            <Card.Content icon="file">
                <NavLink className="hoverLink" to={`${file}`}>{`${fileName}`}</NavLink>
                {editMode && <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleDeleteFilePressed} />}
            </Card.Content>
        </Card>
    );
};

export default FileCard;
